



















import { IGebruiker } from '@/model/IGebruiker';
import { authService } from '@/services/AuthService';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { required } from 'vuelidate/lib/validators';
import { Action, State } from 'vuex-class';

@Component({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  validations: AppGebruikerGegevens.validations
})
export default class AppGebruikerGegevens extends Vue {
  private static validations(this: AppGebruikerGegevens) {
    return {
      state: {
        telefoonnummer: {
          required,
          regex: () => {
            const result = !this.state.telefoonnummer || /^\+?[0-9]{10,}$/.test(this.state.telefoonnummer);
            return result;
          }
        }
      }
    };
  }

  @State(state => state.gebruiker)
  public gebruiker!: IGebruiker;
  @Action('gebruiker/getGebruiker')
  private getGebruiker!: (force?: boolean) => Promise<IGebruiker>;
  @Action('gebruiker/updateTelefoonnummer')
  private updateTelefoonnummer!: (telefoonnummer: string) => Promise<void>;

  public state: { telefoonnummer: string | undefined } = {
    telefoonnummer: undefined
  };

  created() {
    this.getGebruiker().then(g => {
      this.state.telefoonnummer = g.telefoonnummer;
    });
  }

  goBack() {
    this.$router.replace({ name: 'gebruiker-gegevens' });
  }

  save() {
    this.updateTelefoonnummer(this.state.telefoonnummer ?? '').then(() => {
      // go back to uw gegevens
      // todo: we probably shouldn't go back but logout and let auth0 do it's verification dance
      // backend should get notified by auth0 when email is confirmed before the updated email is sent to Boss
      // after logout navigate to page with instructions
      //this.goBack();
      authService.logout();
    });
  }

  cancel() {
    this.goBack();
  }
}
